import React from "react";
import BarekamText from "../../components/text";
import {MessageSections} from "../../components/message/message";
import {Footer} from "../../footer/footer";
import {AuthStatusContainer} from "./styled";
import Message from "../../components/message";
import {LoginContainer} from "../../auth/styled";

const AuthStatus = (props: AuthStatusProps) => {

    return (
        <>
            <LoginContainer>
                <AuthStatusContainer>
                        <BarekamText variant={'xl'} align={"center"} bold>
                            <Message messageKey={props.authStatusTitle} sectionId={MessageSections.LOGIN}/>
                        </BarekamText>

                        <BarekamText variant={'l'} align={"center"} opaque>
                            <Message messageKey={props.authStatusInfo} sectionId={MessageSections.LOGIN}/>
                        </BarekamText>
                </AuthStatusContainer>
            </LoginContainer>

            <Footer/>
        </>
    );
};

export default AuthStatus;

interface AuthStatusProps {
    authStatusTitle: string,
    authStatusInfo: string
}
